// Format a given date as DD-MM-YYYY
export const dateFormatter = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // months are 0-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

// Get range: today to N months ago
export const getDateRange = (count: number): string => {
    const now = new Date();
    const pastDate = new Date(now.getFullYear(), now.getMonth() - count, now.getDate());

    return `${dateFormatter(now)} - ${dateFormatter(pastDate)}`;
}